import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { NotFoundComponent } from './@theme/components';
import { AuthAnonGuard, AuthGuard } from './@core/guards';

const routes: Routes = [
    // {
    //     path: 'app',
    //     loadChildren: () => import('./views/views.module').then(m => m.ViewsModule),
    //     canActivate: [AuthGuard],
    // },
    {
        path: '',
        loadChildren: () => import('./public/public.module').then(m => m.PublicModule),
    },
    // {
    //     path: '',
    //     loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
    //     canActivate: [AuthAnonGuard],
    // },
    { path: '', redirectTo: '/', pathMatch: 'full' },
    { path: '**', component: NotFoundComponent, pathMatch: 'full', data: { title: '404: Not Found' } },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {
}
